/** 错误下 ThreadMonitor 子菜单：只认项目开关 enableThreadMonitor。 */

export const THREAD_MONITOR_SETTING_KEY = 'enableThreadMonitor';

/** 侧栏 ThreadMonitor：只认项目开关，不写死 appId。 */
export function isThreadMonitorMenuEnabled(serverAppSettings) {
  return !!(serverAppSettings && serverAppSettings[THREAD_MONITOR_SETTING_KEY]);
}

/** 同 path 切 ThreadMonitor ↔ 全部错误时，exceptionTypeList 变了就要重拉列表。 */
export function didExceptionTypeListChange(oldSearch, nextSearch) {
  const oldList = new URLSearchParams(oldSearch || '').get('exceptionTypeList') || '';
  const nextList = new URLSearchParams(nextSearch || '').get('exceptionTypeList') || '';
  return oldList !== nextList;
}
